import axios from 'axios'
axios.defaults.baseURL = 'https://hpitreenew.hphcclub.com'
// axios.defaults.baseURL = 'https://hpitree.hphcclub.com'

// 获取参数
export function getQueryVariable(variable){
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i=0;i<vars.length;i++) {
		   var pair = vars[i].split("=");
		   if(pair[0] == variable){return pair[1];}
    }
    return("");
}

// POST传参序列化
// axios.interceptors.request.use(
// 	config => {
// 		if(config.url!="/v1/apis/getServiceTimes"){
// 			const timeDifference = window.sessionStorage.getItem("timeDifference");
// 			if(Math.abs(timeDifference) > 60 * 1000){
// 				config.headers['Accept-Decoding'] = (Math.abs(Math.floor((Date.now() + timeDifference) / 60000) << 1) >> 3).toString(16)
// 			}else{
// 				config.headers['Accept-Decoding'] = (Math.abs(Math.floor((Date.now() + 0) / 60000) << 1) >> 3).toString(16)
// 			}
// 			config.headers['Language'] = window.sessionStorage.getItem("Language");
// 		}
//         return config;
//     },
//     error => {
//         return Promise.reject(error);
//     }
// );


/**
 * POST 请求
 *
 * @param {*} url
 * @param {*} params
 */
export function fetchPost(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params)
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 获取请求
 *
 * @param {*} url
 * @param {*} params
 */
export function fetchGet(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 更新请求
 *
 * @param {*} url
 * @param {*} params
 */
export function fetchPut(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
      .catch((error) => {
        reject(error)
      })
  })
}

/**
 * 删除请求
 *
 * @param {*} url
 * @param {*} params
 */
export function fetchDel(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        params: params
      })
      .then(
        (response) => {
          resolve(response.data)
        },
        (err) => {
          reject(err)
        }
      )
      .catch((error) => {
        reject(error)
      })
  })
}